import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL, Image_URL } from '../App';
import axios from 'axios';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlay, faShieldAlt, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import '../styles/card.css';

function isCourseOwned(attributes = {}) {
  const owned = attributes.Owned ?? attributes.owned ?? attributes.is_enrolled ?? attributes.isEnrolled;
  return (
    owned === true ||
    owned === 1 ||
    owned === '1' ||
    owned === 'true' ||
    String(owned).toLowerCase() === 'true'
  );
}

function CardLogin({ cardcourse , style, ownedCourseIds }) {
  const navigate = useNavigate();
  const attrs = cardcourse?.attributes || {};
  const ownedFromList = ownedCourseIds
    ? ownedCourseIds.has(String(cardcourse?.id)) || ownedCourseIds.has(Number(cardcourse?.id))
    : false;
  const owned = ownedFromList || isCourseOwned(attrs);
  const isExpired = attrs.is_expired === 1 || attrs.is_expired === '1';

  function formatDate(dateString) {
    try {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC', numberingSystem: 'arab' };
      const formatter = new Intl.DateTimeFormat('ar-EG', options);
      return formatter.format(date);
    } catch (e) {
      return '';
    }
  }

  const BuyCourseFree = (coursefree_id) => {
    const token = localStorage.getItem('token');
    const config = { headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': 'any', Authorization: `Bearer ${token}` } };
    axios.get(`${BASE_URL}/api/enrollFree/${coursefree_id}`, config)
      .then(response => { if (response.status === 200) navigate(`/contentcourse/${coursefree_id}`); })
      .catch(() => {
          swal("خطأ", "فشل في الاشتراك", "error");
        });
  };

  return (
    <div className={`stylish-card ${style ? 'dark-mode' : ''} ${isExpired ? 'expired' : ''}`}>
      <div className="image-container">
        <img src={`${Image_URL}/storage/${attrs.img}`} alt={attrs.name} loading="lazy" />
        <div className="overlay"></div>
        <div className="play-icon">
          <FontAwesomeIcon icon={faPlay} />
        </div>
        {owned ? (
          <div className="tag owned-tag">تم الشراء</div>
        ) : attrs.price === '0.00' ? (
          <div className="tag free-tag">مجاني</div>
        ) : attrs.old_price !== '' && attrs.old_price != null ? (
          <div className="tag offer-tag">{`%${(((attrs.old_price - attrs.price) * 100) / attrs.old_price).toFixed(0)} خصم`}</div>
        ) : null}
      </div>
      <div className="content-body">
        <h3 className="card-title">{attrs.name}</h3>
        <div className="card-description" dangerouslySetInnerHTML={{ __html: (attrs.description || '').replace(/\r\n/g, '<br>').replace(/\n/g, '<br>') }}></div>
        <div className="info-bar">
          <div className="info-item">
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>{formatDate(attrs.created_at)}</span>
          </div>
          <div className="info-item">
            <FontAwesomeIcon icon={faShieldAlt} />
            <span>{`${attrs.days_expiry ? `صالح لمدة ${attrs.days_expiry} يوم` : 'صلاحية دائمة'}`}</span>
          </div>
        </div>

        <div className={`actions${owned ? ' single-action' : ''}`}>
          {owned ? (
            <Link
              to={isExpired ? '#' : `/contentcourse/${cardcourse.id}`}
              className={isExpired ? 'btn-disabled' : 'btn-primary'}
            >
              {isExpired ? 'انتهت الصلاحية' : 'تفاصيل الكورس'}
            </Link>
          ) : attrs.price === '0.00' ? (
            <button onClick={() => BuyCourseFree(cardcourse.id)} className="btn-primary">ادخل للكورس المجاني</button>
          ) : (
            <>
              <Link to={`/contentcourse/${cardcourse.id}`} className="btn-secondary">تفاصيل الكورس</Link>
              {attrs.center_attended ? (
                <button className="btn-disabled" style={{backgroundColor: '#dc3545', cursor: 'not-allowed' , color: 'white'}} disabled>
                  <FontAwesomeIcon icon={faExclamationTriangle} /> حضرت في السنتر , مينفعش تشتري خلاص
                </button>
              ) : (
                <Link to={`/week/${cardcourse.id}/subscribe`} className="btn-primary">اشترِ الآن</Link>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CardLogin;
